import { generateOptimalLineup, sortBattingOrder } from './lineup-engine';

export { getCategoryForPos, isEligible } from './lineup-engine';

export const generateAutoLineup = (
  lineup: any[], 
  teamSettings: any, 
  inningLogs?: Record<number, any[]>,
  gameDate?: string,
  tournamentId?: string,
  styleOfPlay?: string
) => {
  const { lineup: generatedLineup } = generateOptimalLineup(lineup, teamSettings, inningLogs, gameDate, tournamentId, styleOfPlay);
  
  // Apply batting strategy after defensive positions are assigned
  const battingStrategy = teamSettings?.battingStrategy || 'None';
  const finalLineup = sortBattingOrder(generatedLineup, battingStrategy);
  
  return finalLineup;
};
